import { useCallback, useContext } from 'react';
import TextCtaType from '~/constants/TextCtaType';
import ModalContext from '~/context/vdp/ModalContext';
import useTextCtaButtonState from '../selectors/useTextCtaButtonState';

const dummyFunction = () => {};

function useClickHandler(): () => void {
  const { isDisabled, type } = useTextCtaButtonState();
  const { setReservableCancelModalOpen } = useContext(ModalContext);

  const cancelPreOrder = useCallback(() => {
    setReservableCancelModalOpen(true);
  }, [setReservableCancelModalOpen]);

  if (isDisabled) return dummyFunction;

  switch (type) {
    case TextCtaType.Default:
      return dummyFunction;
    case TextCtaType.CancelPreOrder:
      return cancelPreOrder;
    default:
      return dummyFunction;
  }
}

export default function useTextButtonHandler(
  onClick: () => void = dummyFunction
) {
  const handleClick = useClickHandler();

  return useCallback(() => {
    onClick();
    handleClick();
  }, [handleClick, onClick]);
}
